import { render, staticRenderFns } from "./NewStockToSummaryEdit.vue?vue&type=template&id=2a0305d2&scoped=true&"
import script from "./NewStockToSummaryEdit.vue?vue&type=script&lang=js&"
export * from "./NewStockToSummaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewStockToSummaryEdit.vue?vue&type=style&index=0&id=2a0305d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0305d2",
  null
  
)

export default component.exports